import { ProviderAddress } from 'domains/billing';
import { Address } from 'domains/contact/types';

export const getProviderAddressLine2 = (address: ProviderAddress) =>
  [[address.city, address.state].filter(Boolean).join(', '), address.zip_code].filter(Boolean).join(' ');

export const getContactAddressLine2 = (address: Address) =>
  [[address.city, address.state].filter(Boolean).join(', '), address.postalCode].filter(Boolean).join(' ');
